export const DURATION_MESSAGES_IN_SEC = 5
export const STOP_COLORS = [
  { bg: '#BAE0FF', text: '#0958D9' },
  { bg: '#FFE7BA', text: '#D46B08' },
  { bg: '#EFDBFF', text: '#531DAB' },
  { bg: '#D9F7BE', text: '#389E0D' },
  { bg: '#B5F5EC', text: '#08979C' },
  { bg: '#FFF1B8', text: '#D48806' }
]
